import { Tag } from "./Types/tagsType";

export const tagValues: Tag = {
	id: 0,
	name: "",
};
